/* Trenboletics — Scroll-Reveal, PDP-Galerie, Sticky-Buy-Leiste */
(function () {
  'use strict';

  function reveal(root) {
    var els = (root || document).querySelectorAll('.tb-in:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.dataset.tbDelay || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function gallery(root) {
    (root || document).querySelectorAll('[data-tb-gallery]').forEach(function (g) {
      if (g.dataset.tbBound) return;
      g.dataset.tbBound = '1';
      var main = g.querySelector('[data-tb-gallery-main]');
      if (!main) return;
      g.querySelectorAll('[data-tb-gallery-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.dataset.tbSrc;
          var srcset = btn.dataset.tbSrcset;
          if (src) main.src = src;
          if (srcset) main.srcset = srcset;
          main.alt = btn.dataset.tbAlt || main.alt;
          g.querySelectorAll('[data-tb-gallery-thumb]').forEach(function (b) {
            b.setAttribute('aria-current', b === btn ? 'true' : 'false');
          });
        });
      });
    });
  }

  function stickyBar(root) {
    (root || document).querySelectorAll('[data-tb-sticky]').forEach(function (bar) {
      if (bar.dataset.tbBound) return;
      bar.dataset.tbBound = '1';
      var anchorId = bar.dataset.tbSticky;
      var anchor = anchorId ? document.getElementById(anchorId) : null;
      if (!anchor || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(anchor);
    });
  }

  function init(root) { reveal(root); gallery(root); stickyBar(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
